import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';

export const voidByCodeStyles = makeStyles(theme => ({
  icon: {
    width: '2.85vw',
    height: '4.16vh',
  },

  background: {
    backgroundColor: themeColor.lightBackground,
  },
  backgroundWhite: {
    backgroundColor: themeColor.white,
  },
  voidByCodeTitleContainer: {
    height: '8.8vh',
  },
  voidByCodeTitleBar: {
    color: themeColor.infoMain,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vh(2.08),
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
  },
  voidByCodeTitleHeader: {
    color: themeColor.modalTitle,
  },
  voidByCodeTitleHeaderLabel: {
    fontSize: vh(4.18),
    fontWeight: 500,
  },
  voidByCodeContainer: {
    padding: 10,
  },
  keypadContainer: {
    alignSelf: 'flex-end',
  },
  outerMostContainer: {
    width: '0',
    marginLeft: '1vh',
  },
  fitHeight: {
    height: 'fit-content',
  },
  containerAlignment: {
    alignSelf: 'center',
    justifyContent: 'center',
  },
  selfAlign: {
    alignSelf: 'flex-end',
  },
  buttonStyles: {
    fontSize: vh(2.1248),
  },
  outerFlexDesign: {
    flex: '1 1 0',
  },
  flexDesign: {
    flex: 1,
  },
}));
